import React from 'react';

function LastRoundData({ resultNumber }) {
  return (
    <div className='fairness-balls-row'>
      {resultNumber.map((el) => {
        return (
          <div className='ball-wrapper' key={el}>
            <div className='ball-content'>{el}</div>
          </div>
        );
      })}
    </div>
  );
}
export default LastRoundData;
